<template>
    <div class="page-jpoint-add">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">集金幣</div>
            <div class="breadcrumb-item">集金幣設置 新增</div>
        </div>

        <div class="card-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="100" push="5">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>類型操作</span>
                                </div>
                            </FormItem>
                            <FormItem>
                                <Select size="small" placeholder="類型" v-model="form.type_id" clearable>
                                    <Option :value="item.id" v-for="(item, index) in pickAddress"
                                            :key="item.id">{{item.name}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="100" push="5">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>類型名稱</span>
                                </div>
                            </FormItem>
                            <FormItem>
                                <Input size="small" clearable v-model="form.name"></Input>
                            </FormItem>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="1000" push="5">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span v-if="form.type_id == null">消費</span>
                                    <span v-if="form.type_id == 1">區間消費</span>
                                    <span v-if="form.type_id == 2">區間消費</span>
                                </div>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>最低消費</span>
                                </div>
                                <InputNumber size="small" v-model="form.interval_smal" :disabled="form.type_id == 2 || form.type_id == null"/></InputNumber>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>最高消費</span>
                                </div>
                                <InputNumber size="small" v-model="form.interval_max" :disabled="form.type_id == 2 || form.type_id == null"></InputNumber>
                            </FormItem>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="1000" push="5">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span v-if="form.type_id == null">獎勵集金幣</span>
                                    <span v-if="form.type_id == 1">區間獎勵集金幣</span>
                                    <span v-if="form.type_id == 2">百分比獎勵集金幣</span>
                                </div>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span v-if="form.type_id == null">獎勵上家 集金幣</span>
                                    <span v-if="form.type_id == 1">獎勵上家 集金幣</span>
                                    <span v-if="form.type_id == 2">獎勵上家 集金幣 (%)</span>
                                </div>

                                <!-- <InputNumber size="small" v-model="form.percentage_superior" :disabled="form.type_id == null" clearable></InputNumber> -->
                                <InputNumber size="small" v-model="form.percentage_superior" clearable :disabled="form.type_id == null"></InputNumber>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                  <span v-if="form.type_id == null">獎勵下家 集金幣</span>
                                    <span v-if="form.type_id == 1">獎勵下家 集金幣</span>
                                    <span v-if="form.type_id == 2">獎勵下家 集金幣 (%)</span>
                                </div>
                                <!-- <InputNumber size="small" clearable v-model="form.percentage_same" :disabled="form.type_id == null"></InputNumber> -->
                                <InputNumber size="small" v-model="form.percentage_same" clearable :disabled="form.type_id == null"></InputNumber>
                            </FormItem>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="100" push="5">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>集金幣有效期</span>
                                </div>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                placeholder="Jpoint有效期" v-model="form.updated_at" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'></DatePicker>
                                </div>
                            </FormItem>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="100" push="5">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>贈送集金幣有效天數</span>
                                </div>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                     <InputNumber size="small" clearable v-model="form.the_term"></InputNumber>
                                </div>
                            </FormItem>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="100" push="5">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>備註</span>
                                </div>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                     <Input size="small" style="width: 200px" clearable v-model="form.remarks"></Input>
                                </div>
                            </FormItem>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="100" push="5">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>是否啟用</span>
                                </div>
                            </FormItem>
                            <FormItem>
                                <RadioGroup v-model="form.status">
                                    <Radio :label="1">
                                        <span>是</span>
                                    </Radio>
                                    <Radio :label="0">
                                        <span>否</span>
                                    </Radio>
                                </RadioGroup>
                            </FormItem>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <Row>
                    <Col span="1000" push="7">
                        <FormItem inline class="pg-form-inline form-input-wrap">
                            <div class="pg-btn-wrap form-submit-wrap">
                                <div class="pg-btn style1" @click="handleCheckForm()">確定</div>
                                <div class="pg-btn" @click="handleBack()">返回</div>
                            </div>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isSubmiting: false,
                pickAddress: [],
                form: {
                    name:'',
                    interval_smal: '',
                    interval_max: '',
                    percentage_same: '',
                    percentage_superior: '',
                    remarks: '',
                    status: '',
                    the_term: '',
                    type_id: null,
                    updated_at: ''
                }
            };
        },
        created(){
            this.getPickAdmin();
        },
        methods: {
            getPickAdmin()
            {
             this.$Rq.requestAuth({
                 url: this.$Api.jpointroleType,
                 method: 'get'
             }).then((res) =>
             {
                 if (res.code == 0)
                 {  
                     this.pickAddress = res.data.data;
                 }
             });
            },
            formatDate(datetime)
            {
                if (!datetime) return '';
            
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },
            handleBack() {
                this.$router.go(-1);
            },
            handleCheckForm() {
                let form = this.form;
                if(form.type_id === null){
                    this.$Utils.showTipInfo('類型操作為空');
                    return;
                }

                if(form.type_id === 1)
                {
                  if (form.name === '')
                  {
                      this.$Utils.showTipInfo('類型名稱為空');
                      return;
                  }
                  if (form.interval_smal === null)
                  {
                      this.$Utils.showTipInfo('區間比獎勵集金幣-最低消費為空');
                      return;
                  }
                  if (form.interval_max === null)
                  {
                      this.$Utils.showTipInfo('區間比獎勵集金幣-最高消費為空');
                      return;
                  }
                  if (form.percentage_superior === null)
                  {
                      this.$Utils.showTipInfo('百分比獎勵集金幣-獎勵上家 集金幣 (%)為空');
                      return;
                  }
                  if (form.percentage_same === null)
                  {
                      this.$Utils.showTipInfo('百分比獎勵集金幣-獎勵下家 集金幣 (%)為空');
                      return;
                  }
                  if (form.updated_at === '')
                  {
                      this.$Utils.showTipInfo('集金幣有效期為空');
                      return;
                  }
                  if (form.the_term === null)
                  {
                      this.$Utils.showTipInfo('贈送集金幣有效天數為空');
                      return;
                  }
                  if (form.remarks === '')
                  {
                      this.$Utils.showTipInfo('備註為空');
                      return;
                  }
                  if (form.status === '')
                  {
                      this.$Utils.showTipInfo('啟用為空');
                      return;
                  }
                }

                if(form.type_id === 2)
                {
                  if (form.interval_smal !== '')
                  {
                      form.interval_smal = '';
                  }
                  if (form.interval_max !== '')
                  {
                      form.interval_max = '';
                  }
                  if (form.name === '')
                  {
                      this.$Utils.showTipInfo('類型名稱為空');
                      return;
                  }
                  if (form.percentage_superior === '')
                  {
                      this.$Utils.showTipInfo('百分比獎勵集金幣-獎勵上家 集金幣 (%)為空');
                      return;
                  }
                  if (form.percentage_same === '')
                  {
                      this.$Utils.showTipInfo('百分比獎勵集金幣-獎勵下家 集金幣 (%)為空');
                      return;
                  }
                  if (form.updated_at === '')
                  {
                      this.$Utils.showTipInfo('集金幣有效期為空');
                      return;
                  }
                  if (form.the_term === '')
                  {
                      this.$Utils.showTipInfo('贈送集金幣有效天數為空');
                      return;
                  }
                  if (form.remarks === '')
                  {
                      this.$Utils.showTipInfo('備註為空');
                      return;
                  }
                  if (form.status === '')
                  {
                      this.$Utils.showTipInfo('啟用為空');
                      return;
                  }
                }
                
                this.handleSubmit();
            },
            handleSubmit() {
                let form = this.form;
                this.isSubmiting = true;
                let params = {};
                params = {
                    name: form.name,
                    interval_smal: form.interval_smal,
                    interval_max: form.interval_max,
                    percentage_same: form.percentage_same,
                    percentage_superior: form.percentage_superior,
                    remarks: form.remarks,
                    status: form.status,
                    the_term: form.the_term,
                    type_id: form.type_id,
                    updated_at: this.formatDate(form.updated_at)
                };
                this.$Rq.requestAuth({
                    url: this.$Api.jpointroleAdd,
                    method: 'post',
                    data: params
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 1) {
                        this.$Utils.showSuccess(res.msg);
                        this.form = {
                            name: '',
                            interval_smal: '',
                            interval_max: '',
                            percentage_same: '',
                            percentage_superior: '',
                            remarks: '',
                            status: '',
                            the_term: '',
                            type_id: null,
                            updated_at: '',
                        };
                    } else {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import 'jpointSettingAdd.scss';
</style>